import { API_BASE_URL } from '../../config'
import {
  FETCH_POSTS_REQUEST,
  FETCH_POSTS_SUCCESS,
  FETCH_POSTS_FAILURE
} from './postsActionTypes'

// Appointment creation
export const CREATE_APPOINTMENT_REQUEST = 'appointments/CREATE_APPOINTMENT_REQUEST'
export const CREATE_APPOINTMENT_SUCCESS = 'appointments/CREATE_APPOINTMENT_SUCCESS'
export const CREATE_APPOINTMENT_FAILURE = 'appointments/CREATE_APPOINTMENT_FAILURE'

export const fetchPosts = (page = 1, pageSize = 5, url = null) => async (dispatch, getState) => {
  const token = localStorage.getItem('auth_token')

  if (!token) {
    dispatch({ type: FETCH_POSTS_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: FETCH_POSTS_REQUEST })

  try {
    const fetchUrl = url || `${API_BASE_URL}/posts/?page=${page}&page_size=${pageSize}`
    const res = await fetch(fetchUrl, {
      headers: {
        'accept': 'application/json',
        'Authorization': `Token ${token}`,
      },
      credentials: 'include'
    })

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}))
      // DRF's paginator 404s with "Invalid page." once we page past the
      // last available result — that's just "no more posts", not a real
      // failure, so treat it like an empty successful page.
      if (res.status === 404 && /invalid page/i.test(errorData.detail || '')) {
        dispatch({
          type: FETCH_POSTS_SUCCESS,
          payload: { results: [], count: 0, next: null, previous: null }
        })
        return
      }
      throw new Error(errorData.detail || 'Failed to fetch posts')
    }

    const data = await res.json()
    dispatch({ type: FETCH_POSTS_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: FETCH_POSTS_FAILURE,
      error: error.message || 'An error occurred while fetching posts'
    })
  }
}

// Thunk for creating an appointment
export const createAppointment = (swipe, scheduled_time, notes) => async (dispatch) => {
  dispatch({ type: CREATE_APPOINTMENT_REQUEST })
  try {
    const token = localStorage.getItem('auth_token') || ''
    const response = await fetch(`${API_BASE_URL}/appointments/`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        swipe,
        scheduled_time,
        notes
      })
    })
    if (!response.ok) {
      const data = await response.json().catch(() => ({}))
      throw new Error(data.detail || 'Failed to create appointment')
    }
    const data = await response.json()
    dispatch({ type: CREATE_APPOINTMENT_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: CREATE_APPOINTMENT_FAILURE, error: error.message })
    throw error
  }
}
